import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-domestic-trucking-services',
  templateUrl: './domestic-trucking-services.component.html',
  styleUrls: ['./domestic-trucking-services.component.scss']
})
export class DomesticTruckingServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
